import * as Sentry from "@sentry/capacitor";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import { AgentStage } from "@/Modules/Agent/Models/Domain";

import { getIntro } from "@/Services/TherapyApi/Agent";

import useAgentStore from "@/Modules/Agent/Store";
import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

async function fetchIntroAH(customerUuid: string) {
  const appStore = useAppStore();
  const agentStore = useAgentStore();

  agentStore.agentStage = AgentStage.LOADING;

  try {
    const response = await getIntro(customerUuid);

    agentStore.intro = response.intro;
  } catch (error) {
    danger(error);
    Sentry.captureException(error);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    agentStore.agentStage = null;
  }
}

export default fetchIntroAH;
